import { useRef } from 'react';

export const useSemanticStableValue = <Value>(
	value: Value,
	areEqual: (current: Value, next: Value) => boolean,
): Value => {
	const stableValueRef = useRef(value);

	if (!areEqual(stableValueRef.current, value)) {
		stableValueRef.current = value;
	}

	return stableValueRef.current;
};
